import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=24d4ae6f&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=24d4ae6f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4ae6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d4ae6f')) {
      api.createRecord('24d4ae6f', component.options)
    } else {
      api.reload('24d4ae6f', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=24d4ae6f&scoped=true", function () {
      api.rerender('24d4ae6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/Upload.vue"
export default component.exports